import React from "react";

const RecordNavigation = ({ history, currentPath, paths }) => {
  const normalizedPaths = Array.isArray(paths) ? paths.filter(Boolean) : [];
  const canNavigate = normalizedPaths.length > 1 && !!currentPath;
  const currentIndex = canNavigate ? normalizedPaths.indexOf(currentPath) : -1;
  const total = normalizedPaths.length;
  const position = currentIndex === -1 ? null : currentIndex + 1;

  if (total === 0) return null;

  const goToIndex = (index) => {
    if (!canNavigate) return;
    if (currentIndex === -1) return;
    const nextPath = normalizedPaths[index];
    if (!nextPath) return;
    history.push({ pathname: nextPath, state: { nav: { paths: normalizedPaths } } });
  };

  const goPrev = () => {
    if (!canNavigate) return;
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + normalizedPaths.length) % normalizedPaths.length;
    goToIndex(prevIndex);
  };

  const goNext = () => {
    if (!canNavigate) return;
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % normalizedPaths.length;
    goToIndex(nextIndex);
  };

  return (
    <div className="btn-group" role="group" aria-label="Record navigation">
      <button
        type="button"
        className="btn btn-light btn-sm"
        onClick={goPrev}
        disabled={!canNavigate || currentIndex === -1}
        title="Previous"
      >
        <i className="fa fa-chevron-left" />
      </button>
      <button
        type="button"
        className="btn btn-light btn-sm"
        disabled
        title={position ? `${position} of ${total}` : undefined}
      >
        {position ? `${position} of ${total}` : `- of ${total}`}
      </button>
      <button
        type="button"
        className="btn btn-light btn-sm"
        onClick={goNext}
        disabled={!canNavigate || currentIndex === -1}
        title="Next"
      >
        <i className="fa fa-chevron-right" />
      </button>
    </div>
  );
};

export default RecordNavigation;
